import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { CommonChartProps } from "../../../../types/General";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const CommonChart: React.FC<CommonChartProps> = ({ title, options, series, colClass }) => {
  return (
    <Col sm="12" className={colClass ? colClass : "col-xl-6 box-col-6"}>
      <Card>
        <CommonCardHeader title={title}/>
        <CardBody>
          <ReactApexChart options={options} series={series} type={options.chart?.type} height={350} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default CommonChart;
